@use 'src/styles/config.module' as *;

.wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  background: $color-grey-light-two;
  padding: 0 2rem 3rem 2rem;
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 2rem 0 2rem;
}

.leftSide {
  align-self: center;
}

.rightSide {
  display: flex;
}

.btnBackToDashboard {
  padding: 0.5rem 1rem;
  border-color: rgba(#95a2a7, 0.3);
}
